import _ from 'underscore';

const deleteNodeFromLevel = (nodes, node) =>
  nodes.filter(n => n.id !== node.id);

export const NodeDeletedHandler = (nodes, node) => {
  const { parents } = node;

  if (_.isEmpty(parents)) {
    return deleteNodeFromLevel(nodes, node);
  }
  const parentIndex = _.findIndex(nodes, n => n.id === parents[0]);
  const preSiblings = nodes.slice(0, parentIndex);
  const postSiblings = nodes.slice(parentIndex + 1);

  const parentNodeChildren = !_.isEmpty(nodes[parentIndex].children)
    ? {
      children: NodeDeletedHandler(
        nodes[parentIndex].children,
        _.extend(node, { parents: parents.slice(1) })
      ),
    }
    : {};
  const parentNode = _.extend(nodes[parentIndex], parentNodeChildren);

  return [...preSiblings, parentNode, ...postSiblings];
};
